<template>
  <div>
    <div class="ibox float-e-margins">
      <div class="ibox-title">
        <h5>รายการเดินบัญชีล่าสุด</h5>
      </div>
      <div class="ibox-content">
        <div class="form-inline" style="margin-bottom:15px;">
          <datepicker :bootstrapStyling="true"
            wrapper-class="form-group"
            language="th"
            v-on:selected="onDateSelected('begin', $event)"
            :value="moreParams.range.begin"
            placeholder="FROM">
          </datepicker>
          <datepicker
            :bootstrapStyling="true"
            wrapper-class="form-group"
            language="th"
            v-on:selected="onDateSelected('ended', $event)"
            :value="moreParams.range.ended"
            placeholder="TO">
          </datepicker>
          <button class="btn btn-info" style="margin-bottom:0" @click="filterRange">GO</button>
          <button class="btn btn-default" style="margin-bottom:0" @click="resetFilterRange">RESET</button>
        </div>
        <div class="table-responsive table-scrollable table-member-transaction  space-loader" v-bind:class="{ loading: loading }">
          <vuetable ref="vuetable"
            :api-url="apiUrl"
            :append-params="appendParams"
            :http-options="httpOptions"
            :fields="fields"
            @vuetable:loading="onLoading"
            @vuetable:loaded="onLoaded"
            :css="css.table"
            @vuetable:row-clicked="onRowClicked"
            pagination-path="links.pagination"
            @vuetable:pagination-data="onPaginationData">
            <template slot="id" slot-scope="props">
              <span :class="{ 'text-underline': isThisToday(props.rowData.created_at) }">{{ props.rowData.id }}</span>
            </template>
            <template slot="type" slot-scope="props">
              {{ props.rowData.credit_turns_id }}
              <div v-html="renderTypeLabel(props.rowData.type, props.rowData.credit_turns_id)"></div>
            </template>
            <template slot="amount" slot-scope="props">
              <span class="text-green" v-if="props.rowData.type === 'deposit'">+{{ props.rowData.amount | number }}</span>
              <span class="text-red" v-else-if="props.rowData.type === 'withdraw'">-{{ props.rowData.amount | number }}</span>
              <span :class="{ 'text-green' : props.rowData.amount >= 0, 'text-red' : props.rowData.amount < 0,  }" v-else>
                <strong><u>{{ props.rowData.amount | number }}</u></strong>
              </span>
            </template>
          </vuetable>
        </div>
        <div class="vuetable-pagination clearfix">
          <div class="pull-left">
            <vuetable-pagination-info ref="paginationInfo"></vuetable-pagination-info>
          </div>
          <div class="pull-right">
            <vuetable-pagination-bootstrap ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination-bootstrap>
          </div>
        </div>
      </div>
    </div>
    <member-stakes-sum :user-id="userId" :reqTransactionId="reqTransactionId"></member-stakes-sum>
  </div>
</template>
<script>
  import moment from 'moment'
  import Datepicker from 'vuejs-datepicker'
  import Vuetable from 'vuetable-2/src/components/Vuetable'
  import VuetablePaginationBootstrap from './VuetablePaginationBootstrap'
  import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
  export default {
    name: 'member-transctions',
    components: {
      Vuetable,
      Datepicker,
      VuetablePaginationBootstrap,
      VuetablePaginationInfo
    },
    props: {
      userId: {
        type: Number
      }
    },
    computed: {
      apiUrl () {
        return `/api/members/${this.userId}/transactions`
      }
    },
    data () {
      return {
        loading:false,
        // dateNow:'',
        reqTransactionId:'',
        css: {
          table: {
            tableClass: 'table table-striped table-bordered table-hover'
          }
        },
        fields: [
          {
            name: '__slot:id',
            title: 'เลขที่รายการ'
          },
          {
            name: '__slot:type',
            title: 'ประเภท',
            callback: 'typeLabel',
            // sortField: 'type',
            titleClass: 'text-center',
            dataClass: 'text-center'
          },
          {
            name: '__slot:amount',
            title: 'ยอดแจ้ง',
            titleClass: 'text-right',
            dataClass: 'text-right'
          },
          {
            name: 'current_credit_chip',
            title: 'ยอดคงเหลือ',
            titleClass: 'text-right',
            dataClass: 'text-right'
          },
          {
            name: 'check_time',
            title: 'วันที่แจ้งฝาก',
            // sortField: 'check_time',
            callback: 'formatDate|DD-MM-YYYY HH:mm',
            titleClass: 'text-right',
            dataClass: 'text-right'
          },
          {
            name: 'created_at',
            title: 'วันที่สั่งดำเนินการ',
            // sortField: 'created_at',
            callback: 'formatDate|DD-MM-YYYY HH:mm',
            titleClass: 'text-right',
            dataClass: 'text-right'
          }
        ],
        appendParams: {
          status: 'success',
          range: {
            begin: '',
            ended: '',
          }
        },
        moreParams: {
          range: {
            begin: moment().format('YYYY-MM-DD'),
            ended: moment().format('YYYY-MM-DD'),
          }
        },
        httpOptions: {
          headers: {
            'X-CSRF-TOKEN': window.App.csrfToken,
            'X-Requested-With': 'XMLHttpRequest',
            'Authorization': 'Bearer ' + window.App.jwtToken
          }
        }
      }
    },
    mounted () {
      //
    },
    methods: {
      resetToToday () {
        this.moreParams.range.begin = moment().format('YYYY-MM-DD')
        this.moreParams.range.ended = moment().format('YYYY-MM-DD')
      },
      transform: (data) => {
        var transformed = data

        const deposit = _.chain(data.data).filter(v => v.type === 'deposit').sumBy('amount').value()
        const withdraw = _.chain(data.data).filter(v => v.type === 'withdraw').sumBy('amount').value()

        transformed.data.push({
          id: 'สรุปยอดรวม',
          type: '-',
          amount: (deposit - withdraw),
          current_credit_chip: '-',
          check_time: null,
          created_at: null,
          updated_at: null
        })

        return transformed
      },
      renderTypeLabel(type, creditTurn) {
        if (['deposit', 'withdraw'].indexOf(type) === -1) {
          return type
        }
        if (type === 'deposit' && creditTurn > 0) return '<span class="label label-warning">D</span>'
        if (type === 'deposit') return '<span class="label label-success">D</span>'
        return '<span class="label label-danger">W</span>'
      },
      typeLabel (type) {
        if (['deposit', 'withdraw'].indexOf(type) === -1) {
          return type
        }
        return (type === 'deposit')
          ? '<span class="label label-success">D</span>'
          : '<span class="label label-danger">W</span>'
      },
      formatDate (value, fmt = 'D MMM YYYY') {
        return (value == null)
          ? '-'
          : moment(value, 'YYYY-MM-DD HH:mm:ss').format(fmt)
      },
      onPaginationData (paginationData) {
        this.$refs.pagination.setPaginationData(paginationData)
        this.$refs.paginationInfo.setPaginationData(paginationData)
      },
      onChangePage (page) {
        this.$refs.vuetable.changePage(page)
      },
      filterRange () {
        this.appendParams = _.assign(this.appendParams, this.moreParams)
        Vue.nextTick( () => this.$refs.vuetable.refresh())
      },
      resetFilterRange () {
        this.resetToToday()
        this.appendParams = { status: 'success' }
        Vue.nextTick( () => this.$refs.vuetable.refresh())
      },
      onDateSelected (v, d) {
        const date = moment(d).format('YYYY-MM-DD')
        this.moreParams.range[v] = date
      },
      isThisToday (date) {
        const compareTime = moment(date)
        return moment(new Date()).diff(compareTime, 'days') === 0
      },
      onRowClicked (data, field, event) {
        const isToday = this.isThisToday(data.created_at)
        // Can check today only.
        if (isToday) {
          this.reqTransactionId = data.id
        }
      },
      onLoading() {
        this.loading=true
      },
      onLoaded() {
        this.loading=false
      }
    }
  }
</script>
<style>
  .table tbody tr{
    cursor: pointer;
  }
  .d-block{
    display: block;
  }

</style>



// WEBPACK FOOTER //
// resources/assets/js/admin/components/MemberTransactions/MemberTransactions.vue